<script setup>
import { useUserStore } from "@/store/user-store";

const store = useUserStore();
</script>

<template>
  <div
    v-if="store.isAuthLoading"
    class="loading-overlay d-flex justify-center align-items-center position-fixed h-100 w-100"
  >
    <div class="spinner"></div>
  </div>
</template>

<style scoped>
.loading-overlay {
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 5px solid #f3f3f3;
  border-top: 5px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
